import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  appVariant: string | null;
  source: string | null;
}

const initialState: AppState = {
  appVariant: localStorage.getItem('app_variant') || null,
  source: localStorage.getItem('source') || null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppParams: (state, action: PayloadAction<{ app_variant: string | null, source: string | null }>) => {
      const { app_variant, source } = action.payload;

      // Update Redux state
      state.appVariant = app_variant || null;
      state.source = source || null;

      // Save to localStorage only if new values are present
      if (app_variant) {
        localStorage.setItem('app_variant', app_variant);
      } else {
        localStorage.removeItem('app_variant'); // Clear if not provided
      }
      if (source) {
        localStorage.setItem('source', source);
      } else {
        localStorage.removeItem('source'); // Clear if not provided
      }
    },
  },
});

export const { setAppParams } = appSlice.actions;
export default appSlice.reducer;
